import { render, staticRenderFns } from "./UpdateRuleIdModal.vue?vue&type=template&id=cc1ea508&"
import script from "./UpdateRuleIdModal.vue?vue&type=script&lang=js&"
export * from "./UpdateRuleIdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports